/* all4school — storefront behaviour */
(function () {
  'use strict';

  /* ---- scroll reveals ---- */
  function reveals() {
    var els = document.querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -4%' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- money formatting (storefront currency) ---- */
  function money(cents) {
    var fmt = window.moneyFormat;
    if (fmt) {
      var val = cents / 100;
      function group(n, ts) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ts); }
      var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount': return group(val.toFixed(2), ',');
          case 'amount_no_decimals': return group(Math.round(val).toFixed(0), ',');
          case 'amount_with_comma_separator': { var p = val.toFixed(2).split('.'); return group(p[0], '.') + ',' + p[1]; }
          case 'amount_no_decimals_with_comma_separator': return group(Math.round(val).toFixed(0), '.');
          case 'amount_with_space_separator': { var q = val.toFixed(2).split('.'); return group(q[0], '\u00a0') + ',' + q[1]; }
          default: return group(val.toFixed(2), ',');
        }
      });
      return out;
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'sk', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }

  /* ---- live cart count ---- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; });
  }
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () { /* keep server-rendered count */ });
  }

  /* ---- sticky header: lift the section wrapper, ribbon slides away ---- */
  function stickyHeader() {
    var bar = document.querySelector('.bar');
    if (!bar) return;
    var wrapper = bar.closest('.shopify-section');
    if (wrapper) wrapper.classList.add('header-section');
  }

  /* ---- mobile menu ---- */
  function mobileMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var panel = document.getElementById('mobile-nav');
    if (!btn || !panel) return;
    function close() { btn.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close(); /* navigating or jumping to an anchor: put the menu away */
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false'); panel.hidden = true; btn.focus();
      }
    });
  }

  /* ---- mega menu (catalogue dropdown) ---- */
  function megaMenu() {
    var btn = document.querySelector('[data-mega-toggle]');
    var panel = document.querySelector('[data-mega-panel]');
    if (!btn || !panel) return;
    function close() { btn.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus(); }
    });
  }

  /* ---- predictive search suggestions ---- */
  function predictiveSearch() {
    var form = document.querySelector('.search-pill');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    var box = document.createElement('div');
    box.className = 'suggest'; box.hidden = true;
    form.appendChild(box);
    var timer = null;
    function hide() { box.hidden = true; box.innerHTML = ''; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var results = ((d || {}).resources || {}).results || {};
            var ps = results.products || [];
            var cols = (results.collections || []).slice(0, 3);
            var pages = (results.pages || []).slice(0, 3);
            if (!ps.length && !cols.length && !pages.length) { hide(); return; }
            var html = ps.map(function (p) {
              var cents = p.price ? Math.round(parseFloat(p.price) * 100) : null;
              return '<a href="' + p.url + '"><span>' + p.title + '</span>' +
                (cents !== null ? '<strong data-money="' + cents + '">' + money(cents) + '</strong>' : '') + '</a>';
            }).join('');
            html += cols.map(function (c) {
              return '<a href="' + c.url + '"><span>' + c.title + '</span></a>';
            }).join('');
            html += pages.map(function (p) {
              return '<a href="' + p.url + '"><span>' + p.title + '</span></a>';
            }).join('');
            box.innerHTML = html;
            box.hidden = false;
            vat.apply(box);
          })
          .catch(hide);
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  /* ---- VAT display toggle (display-only; checkout charges entered prices) ---- */
  var vat = {
    btns: [], rate: 23, mode: 'inc',
    fmt: function (cents) {
      var c = this.mode === 'ex' ? Math.round(cents / (1 + this.rate / 100)) : cents;
      return money(c);
    },
    suffixHTML: function () {
      if (this.mode !== 'ex' || !this.btns.length) return '';
      var lbl = this.btns[0].getAttribute('data-label-ex') || '';
      return lbl ? ' <small class="vat-tag">' + lbl + '</small>' : '';
    },
    apply: function (root) {
      if (!this.btns.length) return;
      var self = this;
      (root || document).querySelectorAll('[data-money]').forEach(function (el) {
        var cents = parseInt(el.getAttribute('data-money'), 10);
        if (isNaN(cents)) return;
        el.innerHTML = self.fmt(cents) + self.suffixHTML();
      });
    },
    sync: function () {
      var self = this;
      this.btns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(self.mode === 'ex'));
        b.classList.toggle('is-ex', self.mode === 'ex');
      });
    },
    init: function () {
      this.btns = Array.prototype.slice.call(document.querySelectorAll('[data-vat-toggle]'));
      if (!this.btns.length) return;
      this.rate = parseFloat(this.btns[0].getAttribute('data-vat-rate')) || 23;
      /* Organisations (B2B) budget without VAT, so default them to ex-VAT prices.
         A stored choice always wins — the toggle stays in the customer's hands. */
      var b2b = document.documentElement.getAttribute('data-b2b') === 'true';
      var stored = null;
      try { stored = localStorage.getItem('a4s-vat'); } catch (e) {}
      this.mode = stored || (b2b ? 'ex' : 'inc');
      var self = this;
      this.sync();
      if (this.mode === 'ex') this.apply();
      this.btns.forEach(function (b) {
        b.addEventListener('click', function () {
          self.mode = self.mode === 'ex' ? 'inc' : 'ex';
          try { localStorage.setItem('a4s-vat', self.mode); } catch (e) {}
          self.sync(); self.apply();
        });
      });
    }
  };

  /* ---- cart drawer ---- */
  var drawer = {
    el: null, overlay: null, items: null, subtotal: null,
    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-drawer-overlay]');
      this.items = document.querySelector('[data-drawer-items]');
      this.subtotal = document.querySelector('[data-drawer-subtotal]');
      if (!this.el) return;
      var self = this;
      this.el.querySelector('[data-drawer-close]').addEventListener('click', function () { self.close(); });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.el.hidden) self.close();
      });
      this.items.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-line]');
        if (!rm) return;
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: parseInt(rm.getAttribute('data-line'), 10), quantity: 0 })
        }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); setCartCount(c.item_count); });
      });
    },
    render: function (cart) {
      if (!this.el) return;
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
      var removeLabel = this.el.getAttribute('data-label-remove') || 'Remove';
      this.items.innerHTML = cart.items.length ? cart.items.map(function (it, i) {
        return '<div class="drawer-line">' +
          '<div><a href="' + it.url + '">' + esc(it.product_title) + '</a>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '') +
          '<small>' + it.quantity + ' × <span data-money="' + it.price + '">' + money(it.price) + '</span></small></div>' +
          '<div class="drawer-line-right"><strong data-money="' + it.final_line_price + '">' + money(it.final_line_price) + '</strong>' +
          '<a href="#" data-line="' + (i + 1) + '">' + removeLabel + '</a></div></div>';
      }).join('') : '<p class="drawer-empty">' + (this.el.getAttribute('data-label-empty') || '') + '</p>';
      this.subtotal.setAttribute('data-money', cart.items_subtotal_price);
      this.subtotal.textContent = money(cart.items_subtotal_price);
/* ux-b5-20261102:F7 start */
      vat.apply(this.el);
      this.updateShippingProgress();
/* ux-b5-20261102:F7 end */
    },
/* ux-b5-20261102:F7 start */
    updateShippingProgress: function () {
      var target = this.el.querySelector('[data-ux-b5-shipping]');
      if (!target) return;
      var sequence = this.shippingSequence = (this.shippingSequence || 0) + 1;
      var self = this;
      target.hidden = true;
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(root + 'cart?section_id=main-cart', {headers: {'Accept': 'text/html'}})
        .then(function (r) { if (!r.ok) throw new Error('Shipping section unavailable'); return r.text(); })
        .then(function (html) {
          if (sequence !== self.shippingSequence) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ux-b5-shipping]');
          target.innerHTML = fresh ? fresh.innerHTML : '';
          target.hidden = !fresh;
        }).catch(function () { if (sequence === self.shippingSequence) { target.innerHTML = ''; target.hidden = true; } });
    },
    open: function () {
/* ux-b5-20261102:F7 end */
      if (!this.el) return;
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        self.render(c);
        self.el.hidden = false; self.overlay.hidden = false;
        document.body.classList.add('drawer-open');
        self.el.querySelector('[data-drawer-close]').focus();
      });
    },
    close: function () {
      this.el.hidden = true; this.overlay.hidden = true;
      document.body.classList.remove('drawer-open');
    }
  };

  /* ---- product options → variant sync ---- */
  function variantSync() {
    var wrap = document.querySelector('[data-product]');
    if (!wrap) return;
    var dataEl = wrap.querySelector('[data-product-json]');
    var idInput = wrap.querySelector('input[name="id"]');
    var selects = Array.prototype.slice.call(wrap.querySelectorAll('[data-option-select]'));
    if (!dataEl || !idInput || !selects.length) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent).variants; } catch (e) { return; }
    var priceEl = wrap.querySelector('[data-price]');
    var btn = wrap.querySelector('[data-add-btn]');
    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (variants[i].options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) { match = variants[i]; break; }
      }
      if (!match) {
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-label-unavailable'); }
        return;
      }
      idInput.value = match.id;
      if (priceEl) { priceEl.setAttribute('data-money', match.cents); priceEl.textContent = match.price; }
      var mirror = document.querySelector('[data-price-mirror]');
      if (mirror) { mirror.setAttribute('data-money', match.cents); mirror.textContent = match.price; }
      var unitEl = wrap.querySelector('[data-unit-price]');
      if (unitEl) {
        var unitMoney = unitEl.querySelector('[data-money]');
        var unitRef = unitEl.querySelector('[data-unit-ref]');
        if (match.unit_cents !== null && match.unit_cents !== undefined && match.unit_ref) {
          if (unitMoney) { unitMoney.setAttribute('data-money', match.unit_cents); unitMoney.textContent = match.unit_price; }
          if (unitRef) { unitRef.textContent = ' / ' + match.unit_ref; }
          unitEl.hidden = false;
        } else {
          unitEl.hidden = true;
        }
      }
      vat.apply(wrap);
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  /* ---- ajax add to cart → open drawer ---- */
  function ajaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      fetch(form.getAttribute('action') + '.js', {
        method: 'POST', body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          if (btn && btn.getAttribute('data-label-added')) {
            btn.textContent = btn.getAttribute('data-label-added');
            setTimeout(function () { btn.textContent = original; }, 2000);
          }
          refreshCartCount();
          drawer.open();
        })
        .catch(function () { form.submit(); });
    });
  }

  /* ---- cookie settings link: open Shopify's consent preferences when available ---- */
  function cookieSettings() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-cookie-settings]');
      if (!a) return;
      var api = window.privacyBanner;
      if (api && typeof api.showPreferences === 'function') { e.preventDefault(); api.showPreferences(); }
      /* else: follow the href to the privacy-choices page */
    });
  }

  /* ---- recently viewed (localStorage) ---- */
  function recentlyViewed() {
    var KEY = 'a4s-recent';
    var payloadEl = document.querySelector('[data-view-payload]');
    var wrap = document.querySelector('[data-recently]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var current = null;
    if (payloadEl) { try { current = JSON.parse(payloadEl.textContent); } catch (e) {} }
    if (wrap && list.length) {
      var items = list.filter(function (p) { return !current || p.handle !== current.handle; }).slice(0, 4);
      if (items.length) {
        wrap.querySelector('[data-recently-items]').innerHTML = items.map(function (p) {
          return '<article class="pack">' + (p.type ? '<span class="tag">' + p.type + '</span>' : '') +
            '<h3><a href="' + p.url + '">' + p.title + '</a></h3><div class="p">' +
            (p.cents ? '<span data-money="' + p.cents + '">' + p.price + '</span>' : p.price) + '</div></article>';
        }).join('');
        wrap.hidden = false;
        vat.apply(wrap);
      }
    }
    if (current) {
      list = [current].concat(list.filter(function (p) { return p.handle !== current.handle; })).slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
  }

  /* ---- sticky mobile buy bar on product pages ---- */
  function buyBar() {
    var bar = document.querySelector('[data-buy-bar]');
    var form = document.querySelector('[data-product] form[action*="/cart/add"]');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var addBtn = form.querySelector('[type="submit"]');
    if (!addBtn) return;
    var io = new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting || window.innerWidth > 900;
    }, { threshold: 0 });
    io.observe(addBtn);
    bar.querySelector('[data-buy-bar-btn]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  /* ---- sticky bar elevation + back-to-top ---- */
  function scrollUX() {
    var bar = document.querySelector('.bar');
    var top = document.querySelector('[data-to-top]');
    function onScroll() {
      var y = window.scrollY || 0;
      if (bar) bar.classList.toggle('scrolled', y > 8);
      if (top) top.classList.toggle('on', y > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0 }); });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    reveals();
    refreshCartCount();
    vat.init();
    stickyHeader();
    mobileMenu();
    megaMenu();
    predictiveSearch();
    drawer.init();
    variantSync();
    ajaxCart();
    scrollUX();
    recentlyViewed();
    cookieSettings();
    buyBar();
  });

  /* re-init when a section is edited in the theme editor */
  document.addEventListener('shopify:section:load', function () {
    reveals(); stickyHeader(); mobileMenu(); megaMenu(); predictiveSearch(); variantSync();
  });
})();
/* ux-20261017:U5 start */
(function () {
  function collectionSwitch() {
    var nav = document.querySelector('nav.col-switch[data-ux-u5]');
/* ux-20261024:P2 start */
    if (!nav || nav.children.length) return;
    var source = document.querySelector('[data-ux-catalogue]');
    if (!source) return;
/* ux-20261024:P2 end */
    nav.replaceChildren();
    source.querySelectorAll('a:not(.mega-all)').forEach(function (original) {
      var link = document.createElement('a');
      link.href = original.href;
      link.textContent = original.querySelector('strong').textContent;
      if (new URL(link.href).pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
      nav.appendChild(link);
    });
    nav.hidden = !nav.children.length;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collectionSwitch);
  else collectionSwitch();
  document.addEventListener('shopify:section:load', collectionSwitch);
})();
/* ux-20261017:U5 end */
/* ux-20261017:U7 start */
(function () {
  function prefillQuote() {
    var body = document.querySelector('.quote-form [name="contact[body]"]');
    if (!body) return;
    var params = new URLSearchParams(window.location.search);
    var product = params.get('produkt');
    if (!product) return;
    var code = params.get('kod');
    if (body.value.trim()) return;
    body.value = product + (code ? ' (kód ' + code + ')' : '') + '\n';
    var topic = document.querySelector('.quote-form select[name="contact[Predmet dopytu]"]');
    // A nonempty default option is not a user choice. Preserve explicit changes/restored choices.
    if (topic && !topic.dataset.uxChanged && !Array.from(topic.options).some(function (o) { return o.defaultSelected && o.value; }) && topic.selectedIndex <= 0) {
      var exact = Array.from(topic.options).find(function (o) { return o.value === product || o.textContent.trim() === product; });
      var other = Array.from(topic.options).find(function (o) { return o.value === 'Iné' || o.textContent.trim() === 'Iné'; });
      if (exact || other) { topic.value = (exact || other).value; topic.dataset.uxPrefilled = 'true'; }
    }
    if (topic) topic.addEventListener('change', function () { topic.dataset.uxChanged = 'true'; }, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefillQuote);
  else prefillQuote();
})();
/* ux-20261017:U7 end */
/* ux-20261024:P3 start */
(function () {
  function collectionIntro() {
    document.querySelectorAll('.template-collection .section-head [data-ux-p3]').forEach(function (intro) {
      if (intro.dataset.uxReady) return;
      intro.dataset.uxReady = 'true';
      var button = intro.nextElementSibling && intro.nextElementSibling.hasAttribute('data-ux-p3-btn') ? intro.nextElementSibling : null;
      if (!button) { button = document.createElement('button'); button.type = 'button'; button.className = 'btn-ghost btn-inline ux-intro-toggle'; button.setAttribute('aria-controls', intro.id); button.hidden = true; intro.after(button); }
      var open = false, mobile = window.matchMedia('(max-width:640px)');
      function update() {
        intro.classList.add('ux-unclamped');
        var fullHeight = intro.getBoundingClientRect().height;
        intro.classList.remove('ux-unclamped');
        var clippedHeight = intro.getBoundingClientRect().height;
        var fits = fullHeight <= clippedHeight + 1;
        button.hidden = !mobile.matches || fits;
        if (button.hidden || open) intro.classList.add('ux-unclamped');
        button.textContent = open ? 'Zobraziť menej' : 'Zobraziť viac';
        button.setAttribute('aria-expanded', String(open));
      }
      button.addEventListener('click', function () { open = !open; update(); });
      window.addEventListener('resize', update);
      if (document.fonts) document.fonts.ready.then(update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collectionIntro);
  else collectionIntro();
  document.addEventListener('shopify:section:load', collectionIntro);
})();
/* ux-20261024:P3 end */
/* ux-b2-20261024:P13 start */
(function () {
  function currentPill() {
    if (!window.matchMedia('(max-width:640px)').matches) return;
    var nav = document.querySelector('nav.col-switch');
    var cur = nav && nav.querySelector('[aria-current]');
    if (!cur || nav.scrollWidth <= nav.clientWidth) return;
    nav.scrollLeft += cur.getBoundingClientRect().left - nav.getBoundingClientRect().left;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', currentPill);
  else currentPill();
  window.addEventListener('load', currentPill);
  document.addEventListener('shopify:section:load', currentPill);
})();
/* ux-b2-20261024:P13 end */
